/** null / undefined / 空文字は未設定。空白だけの文字列は設定済み。 */
export function isUnsetPenname(value?: string | null): boolean {
  return value == null || value === "";
}

function contestPennames(pennames?: string[] | null): string[] {
  if (!pennames) return [];
  return pennames.filter((name) => !!name);
}

/**
 * NP が未設定なら CP のみ。
 * NP が設定済みなら先頭に置き、CP 内の同じ名前は除く。
 */
export function buildDisplayedPennames(nolaPenname?: string | null, pennames?: string[] | null): string[] {
  const contestNames = contestPennames(pennames);
  if (isUnsetPenname(nolaPenname)) return contestNames;
  const rest = contestNames.filter((name) => name !== nolaPenname);
  return [nolaPenname as string, ...rest];
}

/** 先頭を NP、一覧全体を CP にする。0 件なら NP は空文字、CP は空配列。 */
export function splitPennamesForSave(pennames: string[]): { nolaPenname: string; contestPennames: string[] } {
  if (pennames.length === 0) {
    return { nolaPenname: "", contestPennames: [] };
  }
  return {
    nolaPenname: pennames[0],
    contestPennames: [...pennames],
  };
}
